export const priceMixin = {
  methods: {
    $price (price) {
      return this.$t('common.price.HUF', { price: this.$options.filters.numberFormat(price, { rounded: true }) })
    },

    $nonRoundedPrice (price) {
      return this.$t('common.price.HUF', { price: this.$options.filters.numberFormat(price, { rounded: false }) })
    }
  }
}
